import React, { useCallback, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Box, Heading, Text, Spinner, Button } from "grommet";
import { Wifi, FormNext, Refresh } from "grommet-icons";
import GatewayService from "@services/gateway.service";
import { presentToastErrorContent } from "@shared/Toast";
import { useTranslation } from "react-i18next";

export default function GatewaysPage() {
  const [gateways, setGateways] = useState([]);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const { t } = useTranslation();

  const fetchGateways = useCallback(async () => {
    setLoading(true);
    try {
      const res = await GatewayService.getList();
      setGateways(res.data || []);
    } catch (error) {
      presentToastErrorContent(error);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchGateways();
  }, [fetchGateways]);

  return (
    <Box
      align="center"
      justify="start"
      pad="medium"
      gap="medium"
      flex="grow"
      margin={{ bottom: "300px" }}
      width="100%"
    >
      <Box
        direction="row"
        justify="between"
        align="center"
        width="100%"
        gap="medium"
      >
        <Heading level="2" margin={{ bottom: "xsmall" }}>
          {t("gateways.title")}
        </Heading>
        <Button
          icon={loading ? <Spinner size="xsmall" /> : <Refresh />}
          label={t("gateways.refresh")}
          onClick={fetchGateways}
          disabled={loading}
        />
      </Box>

      {!loading && gateways.length === 0 && (
        <Box
          pad="large"
          background="light-2"
          round="medium"
          style={{ maxWidth: 600, width: "100%" }}
        >
          <Text weight="bold">{t("gateways.noGateways")}</Text>
          <Text size="small" color="dark-6">
            {t("gateways.noGatewaysDesc")}
          </Text>
        </Box>
      )}

      <Box width="100%" gap="small" style={{ maxWidth: 700 }}>
        {gateways.map((gateway) => (
          <Box
            key={gateway.gatewayId}
            pad="medium"
            round="small"
            background="white"
            border={{ color: "light-4" }}
            direction="row"
            justify="between"
            align="center"
            onClick={() =>
              navigate(`/gateways/${gateway.gatewayId}`, {
                state: { gateway },
              })
            }
            hoverIndicator
            style={{ cursor: "pointer" }}
          >
            <Box direction="row" align="center" gap="medium">
              <Box round="full" background="brand-light" pad="small">
                <Wifi color="brand" />
              </Box>
              <Box>
                <Text weight="bold" size="large">
                  {gateway.gatewayName}
                </Text>
                <Text size="small" color="dark-6">
                  MAC: {gateway.gatewayMac}
                </Text>
                <Text size="small" color="dark-6">
                  {t("gateways.doorsCount", { count: gateway.lockNum || 0 })}
                </Text>
              </Box>
            </Box>
            <FormNext color="dark-5" />
          </Box>
        ))}
      </Box>
    </Box>
  );
}
